export default "__VITE_ASSET__BGBjvZeY__"